import styled from "styled-components";
import { colors } from '../../../styles/colors';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  text-align: center;
`;

export const IconContainer = styled.div`
  margin-bottom: 24px;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: ${colors.viveoBlueText};
  margin-bottom: 16px;
  font-family: 'Lato';
`;

export const ModalMessage = styled.p`
  font-size: 14px;
  color: ${colors.viveoBlueText};
  margin-bottom: 32px;
  line-height: 1.4;
  font-family: 'Lato';
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 8px;
`;
